export const ROOT_GROUP = '__root__';
export const DEFAULT_COLUMN_WIDTH = 150;
